import styled from "@emotion/styled";
import { DataGrid } from "@mui/x-data-grid";

export const StyledGrid = styled(DataGrid)`
  .MuiTablePagination-selectLabel,
  .MuiTablePagination-displayedRows {
    margin: 0;
  }
`;
